module.exports = __webpack_public_path__ + "0880558edf469ddfde8966330f1650bd.png";